import cmp from './SimpleTooltip'

export default cmp
